<template>
    <div>
        <VeeForm class="form user-form m-5" @submit="onSubmit">
            <h3>{{
                $t("shop.orderDelivery")
                }}</h3>
            <div>
                <label for="company" class="label px-3 text-uppercase pt-2">
                    {{ $t("account.profile.company") }}
                </label>
                <Field type="text" class="form-control" :placeholder="$t('account.profile.company')"
                    :aria-label="$t('account.profile.company')" aria-describedby="basic-addon1"
                    v-model="form.company_name" name="setCompanyName" :rules="required"
                    :label="$t('account.profile.company')" id="company" />
                <ErrorMessage name="setCompanyName" class="text-danger text-small text-end m-0 pt-1" />
            </div>

            <div>
                <label for="first_name" class="label px-3 text-uppercase pt-1">
                    {{ $t("account.profile.firstname") }}
                </label>
                <Field type="text" class="form-control" :placeholder="$t('account.profile.firstname')"
                    :aria-label="$t('account.profile.firstname')" aria-describedby="basic-addon1"
                    v-model="form.first_name" name="first_name" :rules="required"
                    :label="$t('account.profile.firstname')" id="first_name" />
                <ErrorMessage name="first_name" class="text-danger text-small text-end m-0 pt-1" />
            </div>

            <div>
                <label for="last_name" class="label px-3 text-uppercase pt-1">
                    {{ $t("account.profile.surname") }}
                </label>
                <Field type="text" class="form-control" :placeholder="$t('account.profile.surname')"
                    :aria-label="$t('account.profile.surname')" aria-describedby="basic-addon1" v-model="form.last_name"
                    name="last_name" :rules="required" :label="$t('account.profile.surname')" id="last_name" />
                <ErrorMessage name="last_name" class="text-danger text-small text-end m-0 pt-1" />
            </div>

            <div>
                <label for="street" class="label px-3 text-uppercase pt-1">
                    {{ $t("account.profile.streetHouseNr") }}
                </label>
                <Field type="text" class="form-control" :placeholder="$t('account.profile.streetHouseNr')"
                    :aria-label="$t('account.profile.streetHouseNr')" aria-describedby="basic-addon1"
                    v-model="form.street" name="setStreet" :rules="required"
                    :label="$t('account.profile.streetHouseNr')" id="street" />
                <ErrorMessage name="setStreet" class="text-danger text-small text-end m-0 pt-1" />
            </div>

            <div>
                <label for="postal_code" class="label px-3 text-uppercase pt-1">
                    {{ $t("account.profile.postcode") }}
                </label>
                <Field type="text" class="form-control" :placeholder="$t('account.profile.postcode')"
                    :aria-label="$t('account.profile.postcode')" aria-describedby="basic-addon1"
                    v-model="form.postal_code" name="setPostalCode" :rules="required"
                    :label="$t('account.profile.postcode')" id="postal_code" />
                <ErrorMessage name="setPostalCode" class="text-danger text-small text-end m-0 pt-1" />
            </div>

            <div>
                <label for="city" class="label px-3 text-uppercase pt-1">
                    {{ $t("account.profile.location") }}
                </label>
                <Field type="text" class="form-control" :placeholder="$t('account.profile.location')"
                    :aria-label="$t('account.profile.location')" aria-describedby="basic-addon1" v-model="form.city"
                    name="setCity" :rules="required" :label="$t('account.profile.location')" id="city" />
                <ErrorMessage name="setCity" class="text-danger text-small text-end m-0 pt-1" />
            </div>

            <div>
                <label for="country" class="label px-3 text-uppercase pt-1">
                    {{ $t("account.profile.country") }}
                </label>
                <Field as="select" class="form-control" aria-describedby="basic-addon1" v-model="form.country"
                    name="setCountry" :rules="required" :label="$t('account.profile.country')" id="country">
                    <option disabled :value="null">{{ $t("account.profile.choose") }}</option>
                    <option :value="country" v-for="(country, index) in user.allowed_shipping_countries" :key="index">
                        {{ $t(`account.countries.${country.toLowerCase()}`) }}
                    </option>
                </Field>
                <ErrorMessage name="setCountry" class="text-danger text-small text-end m-0 pt-1" />
            </div>

            <div>
                <label for="phone" class="label px-3 text-uppercase pt-1">
                    {{ $t("account.profile.mobile") }}
                </label>
                <Field type="text" class="form-control" :placeholder="$t('account.profile.mobile')"
                    :aria-label="$t('account.profile.mobile')" aria-describedby="basic-addon1" v-model="form.phone"
                    name="setPhone" :rules="required" :label="$t('account.profile.mobile')" id="phone" />
                <ErrorMessage name="setPhone" class="text-danger text-small text-end m-0 pt-1" />
            </div>

            <div class="d-flex align-items-center gap-2">
                <MDBBtn type="submit" color="danger" :disabled="loading"
                    class="d-flex justify-content-center align-items-center">
                    <span>{{ $t("global.buttons.update") }}</span>
                    <Loader :show="loading" :small="true" spinner="spinner.svg" :tiny="true" />
                </MDBBtn>
                <MDBBtn type="button" color="primary" :disabled="loading" @click="closeModal">
                    {{ $t("global.buttons.close") }}
                </MDBBtn>
            </div>
        </VeeForm>
    </div>
</template>

<script setup>
import { reactive, watch, defineProps, defineEmits, ref, computed } from "vue";
import { Form as VeeForm, Field, ErrorMessage, defineRule } from "vee-validate";
import { required } from "@vee-validate/rules";
import Loader from "@/components/General/Loader/index.vue";
import { MDBBtn } from "mdb-vue-ui-kit";
import { OrderService } from "@/services/order.service";
import { useStore } from "vuex";

const props = defineProps({
    editAddress: { type: Object, required: true },
});

const loading = ref(false)

const emit = defineEmits(["close"]);
const store = useStore();

const form = reactive({ ...props.editAddress });
const user = computed(() => store.getters.getMe);

watch(
    () => props.editAddress,
    (val) => Object.assign(form, val || {}),
    { deep: true }
);

const onSubmit = async () => {
    loading.value = true

    await OrderService.updateAddress(form)
    await store.dispatch("me");

    loading.value = false
    emit("close");
};

const closeModal = () => {
    emit("close");
};

defineRule("required", required);
</script>
